import { STATUS_TYPE } from '../../../enum';
import { Order } from '../../order/api/interface';

export interface FindOrderUserWise {
  userId: string;
  limit?: number;
  skip?: number;
  search?: string;
}

export interface InitialState {
  data: Order[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
